import * as React from 'react';
export default {
  React
};